import { render, staticRenderFns } from "./NationalJobComparisonChoice.vue?vue&type=template&id=7936d26b&scoped=true&"
import script from "./NationalJobComparisonChoice.vue?vue&type=script&lang=ts&"
export * from "./NationalJobComparisonChoice.vue?vue&type=script&lang=ts&"
import style0 from "./NationalJobComparisonChoice.vue?vue&type=style&index=0&id=7936d26b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936d26b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VRow})
